export default __webpack_public_path__ + "static/media/checkbox-default.4084bc7a.svg";